function Lang() {
  return (
    <blockquote className="p-4 bg-white">
      <h4 className="h6 mb-3">What It Means</h4>
      <p>The language of the document or a page element is identified.</p>
      <h4 className="h6 mb-3">Why It Matters</h4>
      <p>Identifying the language of the page or portion of page (if different from the page itself) allows screen readers to read the content appropriately.</p>
      <h4 className="h6 mb-3">What To Do</h4>
      <p>Ensure the language is properly identified for the page (e.g., <code>&lt;html lang="en"&gt;</code>). If content within the page is in a language different than the page's language, identify it using a valid lang attribute value (e.g., <code>&lt;p lang="fr"&gt;</code>).</p>
    </blockquote>
  )
}

export default Lang